import {Component, HostBinding, Input, OnDestroy, OnInit} from "@angular/core";
import {FUINavigationService} from "../../navigation.service";
import {FUINavigationTree} from "./navigation-tree.model";
import {FUINavLayoutService} from "../../../nav-layout/nav-layout.service";
import {FUIResponsiveService} from "../../../page/responsive.service";
import {NavigationEnd} from "@angular/router";
import {Subscription} from "rxjs";
import {FUIBreakpoints} from "../../../page/breakpoints.model";

@Component({
    selector: "fui-navigation-tree",
    templateUrl: "./navigation-tree.component.html",
    styleUrls: ["./navigation-tree.component.scss"],
    standalone: false
})
export class FUINavigationTreeComponent implements OnInit, OnDestroy {
    public activeChildren: boolean;
    public activeTree: FUINavigationTree = new FUINavigationTree();
    @Input() tree: FUINavigationTree;

    @HostBinding("class.mobile") private get mobile() {
        return this.navigationService.useMobileNav();
    };

    private subscriptions: Subscription = new Subscription();

    constructor(public navigationService: FUINavigationService,
                private navLayoutService: FUINavLayoutService,
                private responsiveService: FUIResponsiveService) {

    }

    ngOnInit() {
        /**
         * Watch for router events to enact some
         * change page actions - closing out the navgiation modal
         * in accordance with the view size
         */
        this.subscriptions.add(this.navigationService.routerEvents$.subscribe(
            (event) => {
                if (event instanceof NavigationEnd) {
                    if (this.navigationService.useMobileNav()) {
                        this.navigationService.resetActiveModal();
                        this.navLayoutService.toggleFrame(false);
                    } else {
                        this.navigationService.resetActiveModal();
                        this.navigationService.resetActiveTree();
                    }
                }
            }
        ));

        /**
         * Subscribe for changes to the active tree level
         * (this level)
         */
        this.subscriptions.add(this.navigationService.activeTree$.subscribe(
            (isActive) => {
                setTimeout(() => {
                    this.activeTree = isActive;
                })
            }
        ));

        /**
         * Subscribe to the active branch so that the tree level
         * is aware of what is being changed and made active below it
         */
        this.subscriptions.add(this.navigationService.activeBranch$.subscribe(
            (activeBranch) => {
                for (const branch of this.tree.branches) {
                    if (this.navigationService.useMobileNav()) {
                        if (activeBranch === branch) {
                            setTimeout(() => {
                                this.activeChildren = true;
                            });

                            this.navigationService.setActiveTree(this.tree, false);
                        } else {
                            setTimeout(() => {
                                this.activeChildren = false;
                            });
                        }
                    }
                    else {
                        if (activeBranch === branch) {
                            setTimeout(() => {
                                this.activeChildren = true;
                            })
                        }
                        else {
                            setTimeout(() => {
                                this.activeChildren = false;
                            });
                        }
                    }

                }
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Check if current tree is active
     * @param navigationTree
     * @returns {boolean}
     */
    isTreeActive(navigationTree: FUINavigationTree): boolean {
        if (this.activeTree === navigationTree) {
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * Set active states both internally and externally
     * for actions that are relevant to the state of the
     * modal window diplay - such as the overlay in the
     * page component.
     * @param event
     * @param navigationTree
     */
    toggleActiveTree(event: MouseEvent, navigationTree: FUINavigationTree): void {
        if (this.navigationService.useMobileNav()) {
            if (this.activeTree === navigationTree) {
                this.navigationService.resetActiveTree();
            }
            else {
                this.navigationService.setActiveTree(navigationTree);
            }
        } else {
            if (this.activeTree === navigationTree) {
                this.navigationService.resetActiveTree();
                this.navigationService.resetActiveModal();
            }
            else {
                this.navigationService.setActiveTree(navigationTree);
            }
        }
    }

    get componentId(): string {
        return this.tree ? "menu-group-" + this.tree.title.replace(/\./g, "-") : null;
    }
}
